import React, {Component, Fragment} from "react";
import {TableCell} from "@material-ui/core";
import {Done} from "@material-ui/icons";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {getMessage} from "../../util";


class AnswerStateItem extends Component {

    render() {

        const voted = this.props.representative.answers[this.props.question.slug] ? true : false;

        return (
            <Fragment>
                <TableCell>
                    {this.props.representative.identity}
                </TableCell>
                <TableCell>
                    {this.props.representative.data.name ? this.props.representative.data.name : 'unknown'}
                </TableCell>
                {this.props.representative.logged_before_quorum?(
                        this.props.common_shares.length > 0 ? (
                    voted ? (
                        <Fragment>

                            <TableCell>
                                <ListItemIcon>
                                    <Done/>
                                </ListItemIcon> {getMessage(this.props.meeting.meeting_type, 'vote_sent', this.props.messages)}
                            </TableCell>
                        </Fragment>
                    ) : (<Fragment>
                            <TableCell>
                                {getMessage(this.props.meeting.meeting_type, 'vote_pending', this.props.messages)}
                            </TableCell>

                        </Fragment>
                    )
                ):(
                    <TableCell>
                        {getMessage(this.props.meeting.meeting_type, 'question_no_right', this.props.messages)}
                    </TableCell>
                )):(
                    <TableCell >
                        {getMessage(this.props.meeting.meeting_type, 'question_no_attendance', this.props.messages)}
                    </TableCell>
                )}

            </Fragment>
        );
    }
}


export default AnswerStateItem;